import React from 'react';
import CreatableSelect from 'react-select/creatable';
import {SingleValue} from "react-select";
import {IOptionType} from '../../../types/common';

interface ExtractOptionsSelectProps {
    title: string;
    options: IOptionType[];
    selectedOption: IOptionType | null;
    isDisabled: boolean;
    onChange: (value: SingleValue<IOptionType>) => void;
}

const ExtractOptionsSelect: React.FC<ExtractOptionsSelectProps> = ({
                                                                       title,
                                                                       options,
                                                                       selectedOption,
                                                                       isDisabled,
                                                                       onChange
                                                                   }) => (
    <div className="d-flex flex-column gap-2">
        <div className="d-flex flex-row align-items-baseline gap-1">
            <span>{title}</span>
        </div>
        <CreatableSelect
            className="card border-0 d-md-block"
            isDisabled={isDisabled}
            options={options}
            value={selectedOption ? [selectedOption] : []}
            onChange={(choice) => onChange(choice)}
        />
    </div>
);

export default ExtractOptionsSelect;
